/* src/app/user-detail/user-detail.component.scss */
.mat-mdc-cell {
  text-align: left;
}
.status {
  display: inline-block;
  background: #f7f7f7;
  padding: 3px;
  border-radius: 5px;
  padding: 0px 5px;
  text-transform: uppercase;
}
button {
  border-radius: 14px;
  padding: 0px 10px;
}
.mat-column-step,
.mat-column-total_steps,
.mat-column-time_spent {
  max-width: 70px;
  width: 70px;
  padding-right: 10px;
}
.mat-column-codes {
  max-width: 100px;
  width: 100px;
  padding-right: 10px;
}
.mat-column-status {
  max-width: 100px;
  width: 100px;
  padding-right: 10px;
}
.mat-column-actions {
  text-align: right;
  max-width: 236px;
}
/*# sourceMappingURL=user-detail.component.css.map */
